import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import Toggle from "../../components/Toggle";
import { useAuth } from "../../context/AuthContext";

const ROLES = ["customer", "manager", "admin"];

export default function AdminUsers() {
  const { user: currentUser } = useAuth();
  const [users, setUsers] = useState([]);

  const load = () => api.get("/users").then((r) => setUsers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setRole = async (id, role) => {
    await api.put(`/users/${id}/role`, { role });
    toast.success("Role updated");
    load();
  };
  const setSub = async (id, is_subscriber) => {
    await api.put(`/users/${id}/subscription`, { is_subscriber });
    toast.success("Subscription updated");
    load();
  };

  return (
    <div className="mt-6">
      <h3 className="font-display font-semibold text-lg text-[#1A231C] mb-1">Users & Roles</h3>
      <p className="text-sm text-[#5C665D] mb-4">Manage roles (Admin / Store Manager / Customer) and subscription access.</p>
      <div className="bg-white border border-[#E8E4D9] rounded-xl divide-y divide-[#E8E4D9]">
        {users.map((u) => (
          <div key={u.id} data-testid={`admin-user-${u.id}`} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 py-3">
            <div className="min-w-0">
              <p className="text-[#1A231C] font-medium truncate">{u.name} <span className="text-[#5C665D] font-normal">· {u.email}</span></p>
              <p className="text-xs text-[#5C665D]">{new Date(u.created_at).toLocaleDateString()}</p>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <span className="text-xs text-[#5C665D]">Subscriber</span>
                <Toggle checked={!!u.is_subscriber} onChange={(v) => setSub(u.id, v)} testid={`user-sub-${u.id}`} />
              </div>
              <select
                data-testid={`user-role-${u.id}`}
                value={u.role}
                disabled={currentUser?.id === u.id}
                title={currentUser?.id === u.id ? "You cannot change your own admin role" : ""}
                onChange={(e) => setRole(u.id, e.target.value)}
                className="bg-white border border-[#E8E4D9] rounded-lg px-3 py-2 text-sm capitalize focus:outline-none focus:border-[var(--brand-primary)] disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {ROLES.map((r) => (<option key={r} value={r}>{r === "manager" ? "Store Manager" : r}</option>))}
              </select>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
